













































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';
import WidgetService from '../../services/widget.service';
import EventBus from '@/services/eventbus.service';

@Component( {
  components: {
    VueApexCharts,
  },
} )

export default class MeasurementWidget extends Vue {
  @Prop( { default: {} } ) private data!: any;
  private deviceType: number = 0;
  private organisation: string = '';
  private deviceTypes: any[] = [];
  private messageType: string = '';
  private messageTypes: any[] = [];
  private field: string = '';
  private fields: any[] = [];
  private chartSeries: any[] = [];
  private chartOptions: any = {
    xaxis: {
      type: 'datetime',
    },
  };
  private chartType: string = 'area';
  private deviceTypesMessageTypes: Map<number, Map<string, string[]>> = new Map();
  private groupBy: string = '';

  public onOrganisationChange( newOrg: string ) {
    this.clearGraph();
    this.deviceType = 0;
    this.messageType = '';
    this.field = '';
    this.deviceTypes = [];
    this.messageTypes = [];
    this.fields = [];
    const org = this.data.payload.values.find( ( el: any ) => el.slug === newOrg );
    this.organisation = org.name;
    const organisationDevices = org.deviceVersions;
    this.mapFields( organisationDevices );
  }

  public onChartTypeChange( chartType: string ) {
    this.chartType = chartType;
  }

  public onDeviceTypeChange() {
    this.clearGraph();
    this.messageType = '';
    this.field = '';
    if ( !this.deviceType ) {
      this.messageTypes = [];
      this.fields = [];
    } else {
      this.messageTypes = Array.from( this.deviceTypesMessageTypes.get( this.deviceType )!.keys() ).map( ( key: string ) => {
        return {
          text: key.replace( /_/g, ' ' )
              .toLowerCase()
              .split( ' ' )
              .map( ( word: string ) => word.charAt( 0 ).toUpperCase() + word.slice( 1 ) )
              .join( ' ' ),
          value: key,
        };
      } );
      this.fields = [];
    }
    this.data.config.deviceType = this.deviceType;
  }

  public onMessageTypeChange() {
    this.clearGraph();
    this.field = '';
    if ( !this.messageType ) {
      this.fields = [];
    } else {
      const deviceTypeMap = this.deviceTypesMessageTypes.get( this.deviceType )!;
      this.fields = Array.from( deviceTypeMap.get( this.messageType )! ).map( ( key: string ) => {
        return {
          text: key.replace( /_/g, ' ' )
              .toLowerCase()
              .split( ' ' )
              .map( ( word: string ) => word.charAt( 0 ).toUpperCase() + word.slice( 1 ) )
              .join( ' ' ),
          value: key,
        };
      } );
    }
    this.data.config.messageType = this.messageType;
  }

  public async onFieldChange() {
    if ( !this.field ) {
      this.clearGraph();
    } else {
      await this.renderGraph();
    }
    this.data.config.field = this.field;
    const id = this.data.id;
    const payload = this.data;
    delete payload.payload;
    await WidgetService.updateWidget(  id, payload  );
  }

  public clearGraph() {
    // Perform clear here
    this.chartSeries = [];
  }

  public async renderGraph() {
    // Clear the current graph
    this.clearGraph();

    // Get the data
    const orgSlug = this.data.payload.values.find( ( el: any ) => el.name === this.organisation ).slug;
    const result = await WidgetService.getMeasurements( orgSlug, this.messageType, this.field, this.chartType, this.groupBy );

    if (this.groupBy) {
      this.chartSeries = result.results;
    } else {
      this.chartSeries.push( { data: result.results } );
    }

    // Populate the graph
  }

  private mounted() {
    this.applyDefaults();
    EventBus.$on( 'selectMeasurementsOrganisation', this.onOrganisationChange );
    EventBus.$on( 'selectChartType', this.onChartTypeChange );
    EventBus.$on( 'selectGroupBy', this.onGroupByChange );
  }

  private beforeDestroy() {
    EventBus.$off( 'selectMeasurementsOrganisation', this.onOrganisationChange );
    EventBus.$off( 'selectChartType', this.onChartTypeChange );
    EventBus.$off( 'selectGroupBy', this.onGroupByChange );
  }

  private applyDefaults() {
    if ( this.data.config && this.data.config.length !== 0 ) {
      const orgSlug = this.data.config.measurementsSelectedOrg;
      const org = this.data.payload.values.find( ( el: any ) => el.slug === orgSlug );
      this.organisation = org.name;
      this.mapFields( org.deviceVersions );
      this.chartType = this.data.config.chartType;
      this.groupBy = this.data.config.measurementsGroupBy;
      this.deviceType = this.data.config.deviceType;
      this.onDeviceTypeChange();
      this.messageType = this.data.config.messageType;
      this.onMessageTypeChange();
      this.field = this.data.config.field;
      this.onFieldChange();
    } else {
      this.organisation = this.data.payload.values[0].name;
      this.mapFields( this.data.payload.values[0].deviceVersions );
    }

  }

  private mapFields( organisationDevices: any[] ) {
    for ( const deviceType of organisationDevices ) {
      const messageTypesMap = new Map<string, string[]>();
      this.deviceTypes.push( { text: deviceType.name, value: deviceType.id } );
      for ( const field of deviceType.fields ) {
        const messageTypes = messageTypesMap.get( field.message_type ) || [];
        messageTypes.push( field.fieldName );
        messageTypesMap.set( field.message_type, messageTypes );
      }
      this.deviceTypesMessageTypes.set( deviceType.id, messageTypesMap );
    }
  }

  private onGroupByChange( groupBy: string ) {
    this.groupBy = groupBy;
    if ( this.field ) {
      this.renderGraph();
    }
  }
}
